import { Formik, FormikProps } from 'formik';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { updateShowWelcomeChannelAction } from '../../home/actions/HomeActions';
import { UserSettings } from '../services/resources/UserSettings';
import React = require('react');
import { FormikCheckbox } from '../../commonInfra/components/FormikCheckbox';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { InlineCancelAndSaveButtons } from './UserSettingEditButtons';
import _ = require('underscore');

export interface WelcomeBannerFields {
    welcomeChannelEnabled: boolean;
}

export type WelcomeBannerProps = {
    initialValues: WelcomeBannerFields;
}

export function WelcomeBanner(props: WelcomeBannerProps): JSX.Element {

  const[currentWelcomeBannerEnabled, setWelcomeBannerEnabled] = React.useState(props.initialValues.welcomeChannelEnabled);

  async function handleSubmit(values: WelcomeBannerFields) {
    const result: IResult = await UserSettings.updateWelcomeChannelEnabled(values.welcomeChannelEnabled);
    if (!result || result.errors) {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
    } else {
      showNotification(values.welcomeChannelEnabled);
      setWelcomeBannerEnabled(values.welcomeChannelEnabled);
    }
  }

   async function showNotification(welcomeChannelEnabled: boolean) {
    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
    const updateWelcomeChannelAction = updateShowWelcomeChannelAction(welcomeChannelEnabled);
    getAppStore().dispatch(updateWelcomeChannelAction);
  }

  function showButtons(formik: FormikProps<WelcomeBannerFields>, welcomeChannelEnabled: boolean) {
    if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.welcomeChannelEnabled, welcomeChannelEnabled)) {
      return false;
    }
    return true;
  }
   return(
    <Formik
    initialValues={props.initialValues}
    onSubmit={(values: WelcomeBannerFields) => handleSubmit(values)}
    >
      {
        (formik: FormikProps<WelcomeBannerFields>) => (
            <form onSubmit={formik.handleSubmit}>
                <table>
                    <tbody className={UserSettingsStyle.tbody}>
                        <tr data-tb-test-id="userSettings-welcome-banner">
                            <td className={UserSettingsStyle.labelText}>
                                {Messages.settings_welcomeChannel_title()}
                            </td>
                            <td className={UserSettingsStyle.detailsValue}>
                              {Messages.settings_welcomeChannel_myAccountDescription()}
                            </td>
                        </tr>
                        <tr>
                          <td className={UserSettingsStyle.labelText}></td>
                            <td className={UserSettingsStyle.detailsValue}>
                              <FormikCheckbox
                              containerStyle={{marginLeft: 0}}
                              className={UserSettingsStyle.checkBox}
                              testId='Welcome-Banner-Enabled'
                              name={'welcomeChannelEnabled'}
                              label={Messages.settings_welcomeChannel_myAccountCheckbox()}
                              ></FormikCheckbox>
                            </td>
                        </tr>
                        {
                          showButtons(formik, currentWelcomeBannerEnabled) &&
                          <InlineCancelAndSaveButtons
                            testId={'welcome-banner'}
                            formik={formik}
                          />
                        }
                        </tbody>
                    </table>
            </form>
        )
      }

    </Formik>
   );
}